/**
 * Hide toll-free phone number if non-toll-free number has been modified by Google Ads so toll-free number does not get clicked on and reduce conversions
 * 
 * https://jira.plaudit.com/browse/CLTEL-355
 * https://jira.plaudit.com/browse/EDCO-1168
 * 
 * Testing:
 *		Don't click adds, they cost the client a few dollars each time
 *		Append #google-wcc-debug to URL in incognito and click "force" in popup
 */

const phoneLinks = document.querySelectorAll('.contact-layout a[href^="tel:"]');

if (phoneLinks.length > 0) {
	const observer = new MutationObserver((mutationsList) => {
		for (const mutation of mutationsList) {
			if (mutation.type === 'childList' || mutation.type === 'characterData') {
				const target = (mutation.target instanceof Element ? mutation.target : mutation.target.parentElement);
				if (target) {
					//const wrapper = target.closest('.contact__phoneArea') ?? target.closest('a');
					const wrapper = target.closest('a');
					if (wrapper) {
						wrapper.classList.toggle('phoneNumberIsChanged', true);
					}
				}
			}
		}
	});

	const config = {
		characterData: true,
		childList: true,
		attributes: true,
		attributesFilter: ["href"],
		subtree: true,
	};

	phoneLinks.forEach(link => {
		observer.observe(link, config);
	});
}
